<!--
 * @Author: zhaoliang
 * @Date: 2024-06-25 14:05:03
 * @LastEditTime: 2026-01-15 10:25:31
 * @LastEditors: zhaoliang
 * @Description:
 * @FilePath: /visa-canada/src/views/EnquiryForm/Select.vue
 *
-->
<template>
  <div class="select-container">
    <div
      class="content-container"
      ref="contentContainer"
      :class="{ 'err-status': errStatus }"
      @click="showOptions = true"
    >
      <span>{{ label }}</span>
      <img class="select-icon" src="~img/icon-select-down.svg" alt="arrow-up" />
    </div>
    <transition name="fade" v-if="showOptions">
      <div class="options-container" v-clickOutside="handleOutsideClick">
        <div
          v-for="(item, index) in options"
          :key="index"
          class="option-item"
          @click="handleSelect(item.value)"
        >
          {{ item.label }}
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
  import { clickOutside } from '@/utils/directive.js';
  export default {
    name: 'Select',
    components: {},
    directives: { clickOutside },
    props: {
      options: {
        type: Array,
        default: () => [],
      },
      modelValue: {
        type: String,
        default: '',
      },
      errStatus: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        showOptions: false,
      };
    },
    computed: {
      label() {
        return this.options.find(item => item.value === this.modelValue)?.label;
      },
    },
    mounted() {},
    methods: {
      handleOutsideClick(e) {
        const containerELe = this.$refs.contentContainer;
        const isSelfEle = containerELe === e.target;
        const isChildEle = containerELe.contains(e.target);
        if (isSelfEle || isChildEle) {
          this.showOptions = true;
        } else {
          this.showOptions = false;
        }
      },
      handleSelect(value) {
        // this.$emit('update:modelValue', value);
        this.$emit('change', value);
        this.showOptions = false;
      },
    },
  };
</script>
<style lang="scss" scoped>
  .select-container {
    position: relative;
    cursor: pointer;
    @include font(18px, 400);

    .content-container {
      display: flex;
      align-items: center;
      justify-content: space-between;
      box-sizing: border-box;
      width: 100%;
      height: 60px;
      padding: 12px 12px;
      line-height: 34px;
      border: 2px solid #bec7cc;
      border-radius: 10px;
      color: #163049;

      &.err-status {
        border-color: $color-red;
      }

      .select-icon {
        width: 13px;
      }
    }

    .options-container {
      max-height: 400px;
      overflow-y: scroll;
      scrollbar-width: none;
      position: absolute;
      cursor: pointer;
      box-sizing: border-box;
      left: 0;
      top: 65px;
      width: 100%;
      padding: 12px 12px;
      background: #fff;
      // border: 2px solid #bec7cc;
      box-shadow: 0px 0px 5px 2px rgba(0, 0, 0, 0.4);
      border-radius: 10px;
      z-index: 100;
      &::-webkit-scrollbar {
        display: none;
      }

      .option-item {
        @include font(18px, 600);
        padding: 10px 5px;

        &:hover {
          background: #eaeef0;
          border-radius: 5px;
        }
      }
    }
  }

  @media screen and (max-width: 1024px) {
    .select-container {
      @include font(14px, 400);

      .content-container {
        height: 48px;
        line-height: 20px;
      }

      .options-container {
        top: 55px;

        .option-item {
          @include font(14px, 600);
          padding: 10px 5px;
        }
      }
    }
  }
</style>
